/* External */
import { useMemo } from 'react';

/* Utils */
import { WEB_URL_TO_DISPLAY } from '../../../../utils/constants';
import platform from '../../../../utils/platform';
import { useWelcomePageData } from '../../../../providers/ConfigProvider/ConfigProvider';

export function useWelcomePage() {
  const {
    loginTitle,
    registerTitle,
    loginButton,
  } = useWelcomePageData() || {};

  const secondLine = useMemo(() => (
    <>
      { registerTitle }
      {' '}
      {registerTitle && <span className="dtv-html5-c-welcome-page__url">{`${WEB_URL_TO_DISPLAY}${platform.signupUrl}`}</span>}
    </>
  ), [registerTitle]);

  return {
    loginTitle,
    registerTitle: secondLine,
    loginButton,
  };
}
